/**
 *
 * @function updateURLParameter
 * update url parameter
 *
 * @example
 * //http://localhost:3000?category=primary&page=2
 * const urlParams = new URLSearchParams(location.search);
 * const currentPage = urlParams.get('page');
 * const nextPageUrl = updateURLParameter(location.href, 'page', currentPage++);
 * //http://localhost:3000?category=primary&page=3
 *
 * @param {string} url - url to update
 * @param param - param key
 * @param paramVal - param new value
 *
 * @returns {string} newUrl - newUrl with new value
 */
export const addURLParameter = (url, param, paramVal) => {
    if (url.indexOf('?') > -1) {
        return url + '&' + param + '=' + paramVal;
    }
    else {
        return url + '?' + param + '=' + paramVal;
    }
};
export const addURLParameters = (baseUrl, queryParams) => {
    let newUrl = baseUrl;
    for (const [key, value] of Object.entries(queryParams)) {
        newUrl = addURLParameter(newUrl, key, value);
    }
    return newUrl;
};
export const updateURLParameter = (url, param, paramVal) => {
    let newAdditionalURL = '';
    let tempArray = url.split('?');
    let baseURL = tempArray[0];
    let additionalURL = tempArray[1];
    let temp = '';
    if (additionalURL) {
        tempArray = additionalURL.split('&');
        for (let i = 0; i < tempArray.length; i++) {
            if (tempArray[i].split('=')[0] != param) {
                newAdditionalURL += temp + tempArray[i];
                temp = '&';
            }
        }
    }
    let rows_txt = temp + '' + param + '=' + paramVal;
    return baseURL + '?' + newAdditionalURL + rows_txt;
};
/**
 *
 * @function siteUrl
 * return the url stored as sirng in window.siteUrls if exists
 *
 * @param {string} urlName - the URL name in `siteUrls`
 *
 * @returns {string} urlString - the url or undefined if missing
 */
export const siteUrl = (urlName) => {
    if (!window.siteUrls)
        return undefined;
    return window.siteUrls[urlName];
};
